import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const StyledDialog = styled(Dialog)`
  .p-dialog-content {
    padding: 2rem;
    display: flex;
    flex-direction: column;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
`;

interface SessionExpiredDialogProps {
  show: boolean;
  onAccept: () => void;
}

const SessionExpiredDialog: React.FC<SessionExpiredDialogProps> = ({
  show,
  onAccept,
}) => {
  const { t } = useTranslation();

  return (
    <StyledDialog
      header={t("header-session-expired")}
      visible={show}
      style={{ width: "500px" }}
      closable={false}
      closeOnEscape={false}
      dismissableMask={false}
      // dialog can only be closed via the accept button below
      onHide={() => {}}
    >
      <p>{t("text-session-expired")}</p>

      <ButtonContainer>
        <Button label={t("cmd-go-to-login")} onClick={onAccept} />
      </ButtonContainer>
    </StyledDialog>
  );
};

export default SessionExpiredDialog;
